// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueProgressBar from 'vue-progressbar'
import axios from 'axios'
import VueAxios from 'vue-axios'
import router from './router.js'
import store from './store.js'
import Vuelidate from 'vuelidate'

Vue.router = router
Vue.config.productionTip = false
Vue.use(VueAxios, axios)
Vue.axios.defaults.baseURL = process.env.API_URL
Vue.use(Vuelidate)

Vue.use(require('@websanova/vue-auth'), {
  auth: {
    request: function (req, token) {
      this.options.http._setHeaders.call(this, req, {Authorization: 'Bearer ' + token})
    },
    response: function (res) {
      return res.data.token
    }
  },
  http: require('@websanova/vue-auth/drivers/http/axios.1.x'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x'),
  rolesVar: 'role',
  loginData: {
    url: 'auth',
    method: 'POST',
    redirect: '/',
    fetchUser: true
  },
  refreshData: {
    url: 'auth/refresh',
    method: 'POST',
    enabled: true,
    interval: 30
  },
  tokenDefaultName: 'syntaxGAt',
  fetchData: {url: 'user', method: 'GET', enabled: true},
  authRedirect: {name: 'Login'}
})
Vue.use(VueProgressBar, {
  color: store.getters.settings.client.main_color,
  failedColor: store.getters.settings.client.fail_color
})

// Add a request interceptor
Vue.axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  router.app.$Progress.start()
  return config
}, function (error) {
  router.app.$Progress.fail()
  // Do something with request error
  return Promise.reject(error)
})

// Add a response interceptor
Vue.axios.interceptors.response.use(function (response) {
  // Do something with response data
  router.app.$Progress.finish()
  return response
}, function (error, response) {
  if (error.response.status === 401) {
    router.replace('/login')
  }
  router.app.$Progress.fail()
  // Do something with response error
  return Promise.reject(error)
})

Vue.router.beforeEach((to, from, next) => {
  router.app.$Progress.start()
  next()
})

Vue.router.afterEach((to, from) => {
  document.title = to.meta.title ? to.meta.title + ' - ' + store.getters.settings.appName : store.getters.settings.appName
  router.app.$Progress.finish()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {App},
  data: {
    clientSettings: typeof settings !== 'undefined' ? settings : false
  },
  created () {
    if (this.clientSettings) {
      this.$store.dispatch('setSettings', this.clientSettings)
    } else {
      this.$store.dispatch('getSettings')
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js